import { createStyles } from '@mui/styles';
import { APTheme } from "../../../../core/TenantProvider/tenants";

const drawerWidth = 539;

export default (theme: APTheme) => createStyles({
    form: {
        width: "100%"
    },
    input: {
        display: 'none',
    },
    poiBulletPoints: {
        listStyle: "none",
        margin: "0 0 15px 0",
        boxShadow: "none",
        padding: '10px 15px',
        zIndex: 3,
        "& > div": {
            minHeight: 50
        },
        '@media(max-width: 1024px)': {
            padding: '8px 10px',
            margin: "0 0 10px 0",
        },
        '@media(max-width: 768px)': {
            "& > div": {
                minHeight: 40
            },
        },
        "&:last-of-type": {
            marginBottom: 0
        }
    },
    poiBullet: {
        fontWeight: 500,
        position: 'relative',
        padding: '0 0 0 68px',
        display: 'flex',
        alignItems: 'center',
        minHeight: 0,
        '@media(max-width: 1024px)': {
            padding: '0 0 0 55px',
        },
    },
    poiBulletImage: {
        position: "absolute",
        width: 52,
        height: 52,
        left: 0,
        '& svg': {
            display: 'inline-block',
            width: 52,
            height: 52,
            fill: 'currentColor',
            verticalAlign: 'sub',
        },
        '@media(max-width: 1024px)': {
            width: 40,
            height: 40,
            '& svg': {
                width: 40,
                height: 40,
            },
        },
    },
    poiLabel: {
        //marginTop: 10
    },
    textButton: {
        position: "absolute",
        marginTop: 18,
        minWidth: 'auto',
        padding: 0,
        zIndex: 4,
        fontSize: 15,
        letterSpacing: '-0.5px',
        "&:hover, &:active": {
            backgroundColor: 'transparent'
        }
    },
    textButtonOpen: {
        right: 76
    },
    textButtonClosed: {
        right: 46
    },
    hide: {
        display: "none",
    },
    show: {
        display: "block",
    },
    loadingBar: {
        width: "100%"
    },
    uploadButton: {
        border: "1px #a4a4a4 dashed",
        width: 220,
        background: "#FFF",
        color: "#2d91e9",
        "&:hover, &:active": {
            background: "#FFF",
            border: "1px #2d91e9 solid",
        }
    },
    fileInput: {
        display: "none",
    },
    fileInputLabel: {
        width: "100%",
        padding: "5px 0",
        borderRadius: 35
    },
    blueTick: {
        position: "absolute",
        top: 22,
        right: 15,
        width: 26,
        height: 26
    },
    invalidFileTypes: {
        margin: '0 0 10px',
        display: 'flex',
        padding: '14px 15px',
        background: '#f5f5f5',
        alignItems: 'center',
    },
    errorIcon: {
        marginRight: 10
    },
    errorMessage: {
        fontSize: 15,
    },
    withToolTip: {
        marginTop: 25,
    },
    withoutToolTip: {

    },
    mobileHeading: {
        display: 'none',
        [theme.breakpoints.down('lg')]: {
            display: 'flex',
            fontSize: '2.6rem',
            justifyContent: 'center'
        },
        [theme.breakpoints.down('md')]: {
            fontSize: '2rem'
        }
    },
    twoFormsContinue: {
        width: "100%"
    },
    formButtons: {
        display: 'flex',
        justifyContent: 'space-between',
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column-reverse'
        }
    },
    formButtonsLeft: {

    },
    formButtonsRight: {
        justifyContent: 'flex-end'
    },
    formButton: {
        display: "flex",
        width: 200,
        marginBottom: 16,
        [theme.breakpoints.down('lg')]: {
            float: "right",
            width: 200
        },
        [theme.breakpoints.down('md')]: {
            width: '100%'
        }
    },
    poiForm: {
        width: 610,
        [theme.breakpoints.down('lg')]: {
            marginRight: 0,
            marginTop: 30,
            width: "100%"
        }
    },
    poiContainer: {
        margin: "35px 0 35px 35px",
        display: "flex",
        [theme.breakpoints.down('lg')]: {
            width: "100%",
            margin: "0 0 35px 35px",
        },
        [theme.breakpoints.down('md')]: {
            margin: "0 16px 35px"
        }
    },
    centreButtons: {
        textAlign: "center"
    },
    aboveFormSection: {
        width: "100%",
        display: "inline-block",
        height: 30,
        [theme.breakpoints.down('lg')]: {
            width: "100%",
            display: "inline-grid",
            textAlign: "center",
            marginBottom: 62
        }
    },
    helpIcon: {
        width: 22,
        height: 22,
        marginTop: 1
    },
    panelLinkExpanded: {
        right: 75
    },
    panelLinkClosed: {

    },
    skipLink: {
        fontFamily: "CircularStd",
        color: "#2D91E9",
        display: "inline-flex",
        marginTop: "-4px",
        float: "right",
        backgroundColor: "transparent",
        "&:hover, &:active": {
            backgroundColor: 'transparent'
        },
        '@media(max-width: 1024px)': {
            float: "none"
        }
    },
    panelLink: {
        margin: "33px 15px 0 0"
    },
    formSection: {
        padding: 30,
        marginBottom: 0,
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.08)",
        [theme.breakpoints.down('md')]: {
            padding: 20
        },
    },
    formSectionContent: {
        marginTop: 20
    },
    formSectionHeader: {
        marginBottom: 30,
        '@media(max-width: 1024px)': {
            marginBottom: 20,
        },
    },
    formSectionHeading: {
        fontWeight: 500,
        marginBottom: 10,
        display: "inline-flex",
        [theme.breakpoints.down('lg')]: {
            display: "inline-block",
        },
    },
    formSectionSubHeading: {
        marginBottom: 0
    },
    formSectionSubHeadingPoa: {
       fontWeight: 700
    },
    oneSectionHeader: {
        width: "100%",
        display: "block",
        margin: 0,
        height: 24
    },
    twoSectionsHeader: {
        width: "200%",
        display: "block",
        marginBottom: 20,
        height: 44
    },
    oneFormSectionHeading: {
        position: "absolute",
        zIndex: 10,
        left: 116,
        paddingRight: 100,
        background: "#fff"
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: "nowrap",
        position: "absolute",
        right: 0,
        top: 0,
        height: 2000,
        zIndex: 5
    },
    drawerOpen: {
        boxShadow: "-15px 0 15px 0 rgba(0, 0, 0, 0.08)",
        background: "#f5f5f5",
        padding: "30px 65px",
        width: drawerWidth,
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: "hidden",
        width: 539,
        [theme.breakpoints.up("xs")]: {
            width: 539,
        },
    },
    coverForm: {
        position: "absolute",
        top: 70,
        left: "5%",
        zIndex: 10,
        height: 2000,
        width: "100%"
    },
    toolTip: {
        position: "absolute",
        margin: "22px 0 0",
        right: "40px",
        [theme.breakpoints.up("md")]: {
            right: "50px"
        },
    }
});